import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 16px 0 0;
  border-top: 1px solid #d9d9d9;
  margin: 16px 0 0;
`

export const Option = styled.div`
  div {
    color: #363636;
    font-family: Roboto;
    font-weight: 500;
    font-size: 14px;
    width: calc(100% - 67px);
  }
  div + div {
    margin-top: 4px;
    color: #757575;
    font-weight: 400;
  }
  .ant-switch {
    float: right;
  }
`

export const Alert = styled.div`
  border: 1px solid #b6dbfb;
  background-color: #e7f3fe;
  border-radius: 8px;
  padding: 8px;
  color: #363636;
  font-size: 14px;
  font-family: Roboto;
  margin-top: 16px;
  svg {
    margin: 4px 8px 0 4px;
    color: #213f68;
  }
`

export const Content = styled.div`
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 16px 24px;
  margin-top: 16px;
  font-family: Roboto;
  .ant-radio-group {
    margin-bottom: 8px;
    label {
      border: 1px solid #bfbfbf;
      padding: 5px 12px;
      height: 40px;
      font-size: 14px;
      color: #757575;
      font-weight: 700;
      border-radius: 8px 0 0 8px;
    }
    label + label {
      border-radius: 0 8px 8px 0 !important;
    }
    .ant-radio-button-wrapper-checked {
      color: #213f68;
      border-color: #9ecffa;
      background-color: #e7f3fe;
    }
  }
  .form-control {
    height: 40px;
    border: 2px solid #d9d9d9;
    border-radius: 4px;
    box-shadow: none;

    &::placeholder {
      color: #757575;
    }

    &:global(.is-invalid) {
      border-color: #f5222d;
      background-image: none;
      padding-right: 0.75rem;
    }
  }
`

export const Label = styled.div`
  color: #757575;
  font-weight: 700;
  padding-bottom: 4px;
  font-size: 14px;
`
